export default function validatePhoneNumber(val) {
  if (val === null) {
    return false
  }
  const value = val.split("-").join("").split(" ").join("");

  return /^\d{9}$/.test(value)
}